import {useEffect,useState} from 'react'
import moment from 'moment'

//components
import SectionTitle from '../assets/elements/section-subtitle'

//utils
import RequestHelper from '../../utils/helper';

//images
import EmptyStar from '../../images/reviews/star-border.svg'
import FullStar from '../../images/reviews/star-full.svg'
import Quotes from '../../images/reviews/quotes.svg'

//styles
import './styles/reviews.css'

const Reviews = ({maxHeight,data}) => {
  const [localData, setLocalData] = useState({})
  useEffect(() => {
    let formattedData = data?.map(item => {
      let ratings = [item.communicationGrade,item.globalGrade,item.photoGrade,item.priceQualityGrade, item.propertyGrade]
      return{
        rate: Math.round(ratings.reduce((acc,rate) => acc + rate, 0)/ratings.length),
        title: item.title,
        comment: item.comment,
        date: item.dateAdded,
        name: item.addedByName

      }
    })
    
    let info = {
      generalRate: Math.round(formattedData.reduce((acc,item) => acc + item.rate,0)/formattedData.length),
      total: formattedData.length,
      reviews: formattedData
    }
    setLocalData(info)
  }, [data])
  const formattedDate = date => {
    return moment(new Date(date).toISOString()).format(RequestHelper.getLocalDateFormat())
  }
  
  const StarsGenerator = ({qty}) => {
    const stars = []
    for(let i = 0; i < 5; i++)
    {
      if(i < qty)
      {
        stars.push(
          <img src={FullStar} alt="fullstar"/>
        )
      }
      else{
        stars.push(
          <img src={EmptyStar} alt="emptystar"/>
        )
      }
    }
    return <div className='property-details__review__stars'>{stars}</div>
  }
  return (
    <div className='property-details__review'  style={{
      height: `calc(${maxHeight}px - 34px)`,
      overflowY: "hidden"
    }}>
      <SectionTitle>Reviews</SectionTitle>
      <div className='property-details__review__container'>
        <div className='property-details__review__title'>
          <span className='property-details__review__bold'>Rate:</span>
          <StarsGenerator qty={localData?.generalRate}/>
          <span className='property-details__review__total'>({localData?.total} reviews)</span>
        </div>
        <div className='property-details__review__container__allreviews'>
          {localData?.reviews?.map((review,index)=>
            <div className='property-details__review__content'>
              <img src={Quotes} alt="quoteimage" />
              <StarsGenerator qty={review.rate}/>
              <div>{review.title}</div>
              <div className='property-details__review__content__comment'>{review.comment}</div>
              <div className='property-details__review__content__author'>{review.name ? review.name : 'Anonymous'} {formattedDate(review.date)}</div>
              {index < (localData?.reviews?.length - 1) && <div className='property-details__review__content__separator'/>}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
// function mapStateToProps({ details }) {
//   return {
//     floor: details.floor
//   };
// }
// function mapDispatchToProps(dispatch) {
//   return {
//     setFloor: value => dispatch(setFloor(value))
//   }
// }
export default Reviews